<div class="page-body">
  <div>
    <header
      [breadcrumbPath]="breadcrumb"
      [accountType]="accountType"
    ></header>
    <div class="learnmore-columns" >
      
      <div class="learnmore-column learnmore-links">
        <div class="learn-more-toggle">
            <a (click)="toggleMobileLinksCollapse()">
              <span><tra slug="title_learn_more"></tra></span>
              <span class="icon">
                <i *ngIf="isMobileLinksCollapsed" class="fa fa-chevron-right" aria-hidden="true"></i>
                <i *ngIf="!isMobileLinksCollapsed" class="fa fa-chevron-down" aria-hidden="true"></i>
              </span>
            </a>
        </div>
        <div class="learnmore-link-tree" [class.is-mobile-collapsed]="isMobileLinksCollapsed">
          <div class="learnmore-topic"  *ngFor="let topic of getTopics()">
            <a [routerLink]="getNodePath(topic)" class="learnmore-link" [class.is-active]="isTopicSelected(topic)">{{getTitleTranlsated(topic.path)}}</a>
            <div class="learnmore-subtopics-container" *ngIf="topic.sub && topic.sub.length && isTopicSelected(topic)">
              <div class="learnmore-subtopic" *ngFor="let subtopic of topic.sub">
                <a [routerLink]="getNodePath(subtopic)" class="learnmore-link"  [class.is-active]="isSubTopicSelected(subtopic)">{{getTitleTranlsated(subtopic.path)}}</a>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <div class="learnmore-column">
        <h2 class="topic-header"> {{getActiveTopicCaption()}} </h2>
        <markdown class="markdown" ngPreserveWhitespaces [data]="currentArticleContent"></markdown>
      </div>
      
    </div>
  </div>
  <footer [hasLinks]="true"></footer>
</div>

